import { render, staticRenderFns } from "./UserDiscussionList.vue?vue&type=template&id=d165e834&scoped=true&"
import script from "./UserDiscussionList.vue?vue&type=script&lang=js&"
export * from "./UserDiscussionList.vue?vue&type=script&lang=js&"
import style0 from "./UserDiscussionList.vue?vue&type=style&index=0&id=d165e834&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d165e834",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/kreston-is.sdev.cz/httpdocs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d165e834')) {
      api.createRecord('d165e834', component.options)
    } else {
      api.reload('d165e834', component.options)
    }
    module.hot.accept("./UserDiscussionList.vue?vue&type=template&id=d165e834&scoped=true&", function () {
      api.rerender('d165e834', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/parts/dashboard/UserDiscussionList.vue"
export default component.exports